/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import SubscriptionTopicModel from 'cio/models/subscription-topic';
import AnalyticsService from 'cio/services/analytics';
import SubscriptionCenterService from 'cio/services/subscription-center';

interface TableComponentArgs {
  topics?: SubscriptionTopicModel[];
  newTopic?: SubscriptionTopicModel;
  readOnly: boolean;
  isAddingTopic: boolean;
  createNewTopic: () => unknown;
  onCreate: (record: SubscriptionTopicModel) => unknown;
  onCreateCancel: () => unknown;
  subscribedPeopleTotal: number;
}

export default class TableComponent extends Component<TableComponentArgs> {
  @service analytics!: AnalyticsService;
  @service subscriptionCenter!: SubscriptionCenterService;

  get isMissingContent() {
    return this.subscriptionCenter.topicsMissingTranslations.length !== 0;
  }
}
